import {Point, Quad} from 'core/main/Interface';

class Calc {


    constructor() {


    }


    /**
     * used to place child items that need XY adjustments
     * onto parents accurately for various rotations.
     *
     * @param rotation
     * @param offX
     * @param offY
     * @returns {{adjX: number, adjY: number}}
     */
    static getRotationOffsets = (rotation: number, offX: number, offY: number): Point => {

        //let deg2rad = Math.PI / 180;
        //let rad2deg = 180 / Math.PI;
        rotation = Math.round(rotation);

        let adj: number = (rotation + 270) % 360;
        let angle: number = (Math.atan2(offX, -offY) * (180 / Math.PI)) % 360;
        let hyp: number = Math.hypot(offX, offY);
        let rot: number = (adj + angle) * (Math.PI / 180);

        let adjX: number = Math.cos(rot) * hyp;
        let adjY: number = Math.sin(rot) * hyp;

        let point: Point = {
            x: adjX,
            y: adjY
        };
        return point;
    };


    static noOverlap = (a, b): boolean => {

        let result: boolean;

        if (a && b) {
            //console.log((a.x + a.width < b.x), (b.x + b.width < a.x), (a.y + a.height < b.y), (b.y + b.height < a.y));
            result = a.x + a.width < b.x || b.x + b.width < a.x || a.y + a.height < b.y || b.y + b.height < a.y;

        } else {

            result = true;
        }

        return result;
    };


    static sortNumeric = (numArray: number[]): number[] => {
        numArray.sort((a, b) => (a - b))
        return numArray;
    };


    static getPolygonIntersect = (poly1: any, poly2: any): boolean => {

        //console.log('getPolygonIntersect');

        let a: any = poly1.ybox.node;

        let b: any = poly2.ybox.node;

        let aLoc: any = a.getScreenCTM();
        let bLoc: any = b.getScreenCTM();


        let aPoints: SVGPointList = a.points;
        let m: number = aPoints.numberOfItems;

        let bPoints: SVGPointList = b.points;
        let n: number = bPoints.numberOfItems;

        let a1: SVGPoint;
        let a2: SVGPoint;
        let b1: SVGPoint;
        let b2: SVGPoint;

        let i: number;
        let k: number;

        let p: number;
        let q: number;

        for (i = 0; i < m; i++) {

            a1 = aPoints.getItem(i).matrixTransform(aLoc);

            p = (i < m - 1) ? i + 1 : 0;

            a2 = aPoints.getItem(p).matrixTransform(aLoc);

            for (k = 0; k < n; k++) {

                b1 = bPoints.getItem(k).matrixTransform(bLoc);

                q = (k < n - 1) ? k + 1 : 0;

                b2 = bPoints.getItem(q).matrixTransform(bLoc);

                let x: number = Math.round(a1.x);

                //---return false or intersect point ---
                let intersect: boolean = Calc.lineSegmentIntersect(
                    Math.round(a1.x), Math.round(a1.y),
                    Math.round(a2.x), Math.round(a2.y),
                    Math.round(b1.x), Math.round(b1.y),
                    Math.round(b2.x), Math.round(b2.y));

                if (intersect === true) {

                    //console.log(a1.x, a1.y, a2.x, a2.y, b1.x, b1.y, b2.x, b2.y);

                    return true;
                }

            }
        }
        return false;
    };


    //---compare two lines: A.B---
    static lineSegmentIntersect = (
        aX1: number, aY1: number,
        aX2: number, aY2: number,
        bX1: number, bY1: number,
        bX2: number, bY2: number): boolean => {

        let v1: number = (bY2 - bY1) * (aX2 - aX1) - (bX2 - bX1) * (aY2 - aY1);
        let v2: number = (bY2 - bY1) * (aX2 - aX1) - (bX2 - bX1) * (aY2 - aY1);

        if (v1 == 0) v1 = 1;
        if (v2 == 0) v2 = 1;

        let Va: number = ((bX2 - bX1) * (aY1 - bY1) - (bY2 - bY1) * (aX1 - bX1)) / v1;
        let Vb: number = ((aX2 - aX1) * (aY1 - bY1) - (aY2 - aY1) * (aX1 - bX1)) / v2;

        let result = false;

        return (Va >= 0 && Va < 1 && Vb > 0 && Vb < 1) ? true : false;

    };


    /**
     * used to calculate the new matrix when scaling and rotating in the same operation
     * eg: when loading items for a saved design.
     *
     * @param scale
     * @param r
     * @returns {{a: number, b: number, c: number, d: number}}
     */
    static calculateNewMatrix = (scale: number, r: number): Quad => {

        let scale_a: number = scale;
        let scale_b: number = scale * 0.71;
        let a: number = 0;
        let b: number = 0;
        let c: number = 0;
        let d: number = 0;

        switch (r) {

            case 0:
                a = scale_a;
                // b = 0;
                // c = 0;
                d = scale_a;
                break;

            case -270:
            case 90:
                //a = 0;
                b = scale_a;
                c = -scale_a;
                //d = 0;
                break;

            case 180:
            case -180:
                a = -scale_a;
                //b = 0;
                //c = 0;
                d = -scale_a;
                break;

            case 270:
            case -90:
                //a = 0;
                b = -scale_a;
                c = scale_a;
                //d = 0
                break;

            case 45:
            case -315:
                a = scale_b;
                b = scale_b;
                c = -scale_b;
                d = scale_b;
                break;

            case 135:
            case -225:
                a = -scale_b;
                b = scale_b;
                c = -scale_b;
                d = -scale_b;
                break;

            case 225:
            case -135:
                a = -scale_b;
                b = -scale_b;
                c = scale_b;
                d = -scale_b;
                break;

            case 315:
            case -45:
                a = scale_b;
                b = -scale_b;
                c = scale_b;
                d = scale_b;
                break;

        }

        return {a, b, c, d};
    }
}

export {Calc};

